import { IContractFormikStatus } from 'services/templates/types';
import { contractTemplateFormInitialStatus } from '../form/contractTemplateFormInitialStatus';

export const paragraphSectionTemplateInitialStatus: IContractFormikStatus = {
  ...contractTemplateFormInitialStatus,
  minDepth: 2,
};
